import React from 'react';
import { makeStyles } from '@smile-next/uikit';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 80,
        width: '100%',
    },
}));

export const LoginFormFooter: React.FC = (props) => {
    const classes = useStyles();
    return <div className={classes.root}>{props.children}</div>;
};
